import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function BundleSection() {
  const items = [{
    title: "Guía Digital 'De Caos a Calma'",
    desc: '(80 páginas) El paso a paso diario de 30 días.'
  }, {
    title: "Planificador 'Caos Cero'",
    desc: '(PDF) Organizador visual diseñado para mentes con TDAH.'
  }, {
    title: 'Guía de Suplementación Inteligente',
    desc: 'Qué tomar para calmar el sistema nervioso de forma natural.'
  }];
  return <section className="py-24 bg-cream" data-id="element-36">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-37">
        <FadeIn className="text-center mb-16" data-id="element-38">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-39">
            Lo Que Recibes Hoy
          </h2>
          <p className="text-xl text-brown-light font-heading italic" data-id="element-40">
            El paquete completo de herramientas
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-41">
          <FadeIn direction="right" className="order-2 lg:order-1" data-id="element-42">
            <div className="space-y-6" data-id="element-43">
              {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-6 bg-warm-deep/30 rounded-2xl border border-warm-deep hover:bg-warm-deep/50 transition-colors" data-id="element-44">
                  <div className="text-gold mt-1 flex-shrink-0" data-id="element-45">
                    <CheckCircle2 size={24} data-id="element-46" />
                  </div>
                  <div data-id="element-47">
                    <h3 className="text-xl font-bold text-brown mb-1" data-id="element-48">
                      {item.title}
                    </h3>
                    <p className="text-brown-light" data-id="element-49">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn direction="left" className="order-1 lg:order-2 relative" data-id="element-50">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold/10 to-sage/10 rounded-full blur-3xl -z-10" data-id="element-51" />
            <img src="https://cdn.magicpatterns.com/uploads/5CGgkmwMoWn4AChkESpcuT/mockup_.png" alt="Bundle de productos" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-52" />
          </FadeIn>
        </div>
      </div>
    </section>;
}